import { QRCodeCanvas } from "qrcode.react"
import { Modal } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { Machine } from "../../../utils/models/Machine";
import { useEffect, useRef, useState } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import QRFile from "../QRFile/QRFile";

const ModalQRCode = (props: { showModal: boolean, onHide: () => void, machine: Machine }) => {
    const { t } = useTranslation();
    const qrCoderef = useRef<HTMLDivElement>(null);
    const [qrSVG, setQrSVG] = useState('')
    const [machineCode, setMachineCode] = useState('')

    useEffect(() => {
        if (props.machine.token.length > 0 && props.showModal) {
            setMachineCode(`${props.machine.token}`)
        }
    }, [props.machine, props.showModal])

    useEffect(() => {
        if (qrCoderef && qrCoderef.current) {
            const canvas = qrCoderef.current.querySelector('canvas')
            if (canvas) {
                const dataUrl = canvas.toDataURL('image/png')
                setQrSVG(dataUrl || '')
            }
        }
    }, [machineCode])


    return (
        <Modal show={props.showModal} onHide={props.onHide}>
            <Modal.Header>
                <Modal.Title className="w-100 text-center">{t('CharacteristicsPlate')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mt-2 d-flex flex-column align-items-center">
                    {machineCode.length > 0 &&
                        <div ref={qrCoderef}>
                            <QRCodeCanvas value={`${"https://demo.awayter.com/addmachine/?id=0.a3a5c314cce04d0"}`} size={256} />
                        </div>
                    }
                    <div className="d-flex flex-row">
                        {qrSVG.length > 0 && (
                            <button className="btn-Custom btn-IDGreen mt-4">

                                <PDFDownloadLink
                                    document={<QRFile machineCode={machineCode} machine={props.machine} qrCode={qrSVG} />}
                                    fileName={`${props.machine.name}`}
                                >
                                    {t('Descargar')}
                                </PDFDownloadLink>
                            </button>
                        )}
                        <button className="btn btn-danger mt-4 ms-2" onClick={props.onHide}>{t('Cancel')}</button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalQRCode;
